export default __webpack_public_path__ + "static/media/logoWhite.dcc476f5.svg";